import * as React from "react";
import { loader } from "graphql.macro";
import {
  InstantTournamentGetUsersToInviteQuery,
  InstantTournamentGetUsersToInviteQueryVariables,
} from "./graphql/InstantTournamentGetUsersToInvite.generated";
import { useQuery } from "../../../hooks/useQuery";
import { useTranslation } from "react-i18next";
import { REFETCH_PLAYER_INVITES_INTERVAL } from "../../../config";
import {
  InvitePlayerButton, //common/game/InvitePlayers
  useInvitePlayerContext,
  InvitePlayersModal,
} from "./InvitePlayersModal";

const GET_USERS_TO_INVITE_QUERY = loader(
  "./graphql/InstantTournamentGetUsersToInvite.graphql"
);

const Button = React.memo<{
  onClick: (playerId: string) => Promise<any>;
  invitations: Array<string>;
}>(({ onClick, invitations }) => {
  const { id } = useInvitePlayerContext();
  const { t } = useTranslation();
  const waitingConfirmation = invitations.indexOf(id) >= 0;
  return (
    <InvitePlayerButton
      disabled={waitingConfirmation}
      onClick={(player) => onClick(player.id)}
    >
      {waitingConfirmation ? t("waiting_invitation_confirmation") : t("invite")}
    </InvitePlayerButton>
  );
});

export const InvitePlayers = ({
  tournamentId,
  onClose,
}: {
  tournamentId: string;
  onClose: () => void;
}) => {
  const [{ data }] = useQuery<
    InstantTournamentGetUsersToInviteQuery,
    InstantTournamentGetUsersToInviteQueryVariables
  >({
    query: GET_USERS_TO_INVITE_QUERY,
    variables: {
      tournamentId: tournamentId,
    },
    pollInterval: REFETCH_PLAYER_INVITES_INTERVAL,
    requestPolicy: "network-only",
  });

  return (
    <InvitePlayersModal
      players={data?.instantTournamentGetUsersToInvite || []}
      tournamentId={tournamentId}
      exclude={[]}
      onClose={onClose}
    />
  );
};
